<template>
    <div class="flyout-data flyout-data__center grid grid__all-around grid__flyout-data" :class="[bemFacet]">
        <div class="grid--row flyout-data--row flyout-data--row__dot-separator-outer">
            <div class="flyout-data--col grid--col">
                <a :href="teaser.link.content.href" @click.prevent="onTeaserClick()"
                        class="u-reset flyout-data--teaser flyout-teaser">
                    <span class="flyout-teaser--quote">
                        <span class="flyout-teaser--quote-text" v-text="teaser.quote"></span>
                    </span>

                    <span class="flyout-teaser--btn btn btn__outline btn__small" data-inert>
                        <span class="btn--wrap">
                            <span class="btn--text" v-html="teaser.link.content.label"></span>
                            <span class="btn--icon">
                                <cmp-icon symbol="chevron_right" size="x-small"></cmp-icon>
                            </span>
                        </span>
                    </span>
                </a>
            </div>
            <div class="flyout-data--col grid--col">
                <div class="grid--row flyout-data--row flyout-data--row__dot-separator-inner" v-if="links.length">
                    <div v-for="(link, idx) in links" class="flyout-data--col flyout-data--col__vertical grid--col">
                        <cmp-rich-button class="flyout-data--rich-button"
                                button-facet="main-nav"
                                :plugin="link">
                        </cmp-rich-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import navItemMixin from 'vue/mixins/nav-item';


    export default {
        mixins: [
            navItemMixin,
            bemMixin('flyout-data'),
        ],
        props: {
            item: Object,
        },
        computed: {
            teaser() {
                return this.item.flyout.teaser;
            },
            links() {
                return this.item.flyout.links;
            },
        },
        methods: {
            onTeaserClick() {
                this.$router.push(this.teaser.link.content.href);
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?598cf920